import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchFahrerFuhrpark, fetchFahrerUndUser, sendFahrerMails, removeFahrer } from '../../actions'

/*
const createFNLink = ({ onHover, children }) => {
	<div className="hover">
		<div className="hover__no-hover">{children}</div>
		<div className="hover_hover">{onHover}</div>
	</div>
}
*/

class FahrerUndUserList extends Component {

	constructor (props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleEmailVerschicken = this.handleEmailVerschicken.bind(this);
		this.handleEmailLoeschen = this.handleEmailLoeschen.bind(this);
		this.state = {
			selectedRows: [],
			isShowingEmailError: false,
			modalText: "Sie haben keine Email zum Verschicken ausgewählt."
		}
	}

	componentDidMount() {
		console.log("componentDidMount in der Fahrerliste.");
		this.props.fetchFahrerFuhrpark();
		this.props.fetchFahrerUndUser();
	}

	toggleRow(id) {
		const isIncluded = this.state.selectedRows.includes(id);

		if (!isIncluded) {
			this.setState({ selectedRows: [...this.state.selectedRows, id]});
		} else {
			var array = [...this.state.selectedRows];
			const index = array.indexOf(id);
			array.splice(index, 1);
			this.setState({selectedRows: array});
		}
	}

	testSelected(id) {
		return this.state.selectedRows.includes(id);
	}

  handleClick(e) {
		;
	}

	handleChange(e) {
		;
	}

	handleEmailVerschicken(e) {
		e.preventDefault();

		const emailListLength = this.state.selectedRows.length;

		if (emailListLength > 0) {
			this.props.sendFahrerMails(this.state.selectedRows);
			this.setState({selectedRows: []});
		} 
	}

	handleEmailLoeschen(e) {
		e.preventDefault();

		const emailListLength = this.state.selectedRows.length;
		if (emailListLength > 0) {

			this.props.removeFahrer(this.state.selectedRows);
		}
	}

	localDateString(einDatum) {
		const d = new Date(einDatum);

		return (
			<React.Fragment>
				<span>{`${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`}</span>
				<span> <i className="material-icons left" style={{verticalAlign: 'middle'}}>done</i></span>
			</React.Fragment>
		)
	}

	renderFahrer() {
		const ks = Object.keys(this.props.fahrerUndUser).sort();
		console.log(ks);
		return ks.map((k,i) => {
			const fahrerMail = k;
			const userMail = this.props.fahrerUndUser[k];

			return (
				<tr key={fahrerMail}>
					<td>{i+1}</td>
					<td>{fahrerMail}</td>
					<td>{userMail}</td>
				</tr>

			)
		})
	}

	render() {
		return (
			<div>
				<h4 style={{fontStyle:'italic'}}>Teilnehmer insgesamt (mit jeweiligem Fuhrparkleiter)</h4>
				<form>
				 <table className="table table-striped w-100">
					<thead style={{backgroundColor: '#e6e6e6'}}>
						<tr>
								<th>Nummer</th>
								<th>Email</th>
								<th>User (Fuhrpark)</th>
						</tr>
					</thead>
					<tbody>{this.renderFahrer()}
					</tbody>
				</table>
			</form>
		</div>
		);
	}
}

const mapDispatchToProps = {
	fetchFahrerFuhrpark,
	fetchFahrerUndUser,
	sendFahrerMails,
	removeFahrer
}

function mapStateToProps({fahrer, auth, hinweis, fahrerUndUser}) {
	return { fahrer, auth, hinweis, fahrerUndUser }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(FahrerUndUserList);



// WEBPACK FOOTER //
// ./src/components/fahrer/FahrerUndUserList.js